import { useFormContext, Controller } from 'react-hook-form';
import { Autocomplete, AutocompleteProps, AutocompleteValue, TextField } from '@mui/material';

interface Props<
    T,
    Multiple extends boolean | undefined,
    DisableClearable extends boolean | undefined,
    FreeSolo extends boolean | undefined
> extends AutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {
  name: string;
  label?: string;
  helperText?: React.ReactNode;
  onChangeCustom?: any;
}

export default function RHFAutocomplete<
    T,
    Multiple extends boolean | undefined,
    DisableClearable extends boolean | undefined,
    FreeSolo extends boolean | undefined
>({
    name,
    label,
    helperText,
    onChangeCustom,
    ...other
  }: Omit<Props<T, Multiple, DisableClearable, FreeSolo>, 'renderInput'>) {
  const { control, setValue } = useFormContext();
  if (!other.options.length) {
    return null;
  }
  const handleChange = (
      event: React.SyntheticEvent<Element, Event>,
      newValue: AutocompleteValue<T, Multiple, DisableClearable, FreeSolo>
  ) => {
    setValue(name, newValue, { shouldValidate: true });
    onChangeCustom?.(newValue);
  };
  return (
      <Controller
          name={name}
          control={control}
          render={({ field, fieldState: { error } }) => (
              <Autocomplete
                  {...field}
                  fullWidth
                  onChange={handleChange}
                  renderInput={(params) => (
                      <TextField
                          label={label}
                          error={!!error}
                          helperText={error ? error?.message : helperText}
                          {...params}
                      />
                  )}
                  {...other}
              />
          )}
      />
  );
}
